if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.upsell = document.querySelector("product-upsell");
        this.saleButton = document.querySelector(".product__media-sale-button");

        this.form = this.querySelector("form");

        if (!this.form) {
          return;
        }

        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");

        this.submitButton = this.querySelector('[type="submit"]');
        if (this.saleButton) {
          this.saleButton.addEventListener("click", () =>
            this.submitButton.click(),
          );
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        //this.cartNotification.setActiveElement(document.activeElement);

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        this.querySelectorAll(".loading-overlay__spinner").forEach(
          (spinner) => {
            spinner.classList.remove("hidden");
          },
        );

        this.querySelectorAll("[type='submit']").forEach((submitButton) => {
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
        });

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        const formData = new FormData(this.form);

        if (this.upsell && this.upsell.getProduct()) {
          formData.delete("id");
          formData.delete("quantity");
          formData.append("items[0][id]", formData.get("id"));
          formData.append("items[0][quantity]", 1);
          formData.append("items[1][id]", this.upsell.getProduct());
          formData.append("items[1][quantity]", 1);
          formData.append(
            "sections",
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
              .join(","),
          );
          formData.append("sections_url", window.location.pathname);
        } else {
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id),
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          if (document.querySelectorAll("[name='bundle[]']")) {
            const bundle = document.querySelectorAll("[name='bundle[]']");
            formData.append(
              "properties[_bundle_products]",
              Array.from(bundle)
                .map((item) => item.value)
                .join(),
            );
          }
        }

        delete config.headers["Content-Type"];
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;

              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    if (this.cart.productAddedToCart)
                      this.cart.productAddedToCart();
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              if (this.cart.productAddedToCart) this.cart.productAddedToCart();
              if (window.giftProduct) {
                this.addFreeProductToCart();
              }
            }

            document.dispatchEvent(
              new CustomEvent("add-to-cart-submit", {
                bubbles: true,
                cancelable: true,
                detail: {
                  product: response,
                },
              }),
            );
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");

            this.querySelectorAll("[type='submit']").forEach((submitButton) => {
              if (!this.error) submitButton.removeAttribute("aria-disabled");

              submitButton.classList.remove("loading");
            });

            this.querySelectorAll(".loading-overlay__spinner").forEach(
              (spinner) => {
                spinner.classList.add("hidden");
              },
            );
          });
      }

      addFreeProductToCart() {
        window
          .fetch("/cart.js")
          .then((res) => res.json())
          .then((res) => {
            var cartItems = res.items,
              freeProductInCart = cartItems.some(
                function (element, index, array) {
                  return element.variant_id == window.giftProduct.id;
                },
              );

            const cartTotal = res.total_price;
            const otherProductInCart = cartItems.some(
              (element) => element.variant_id != window.giftProduct.id,
            );

            if (
              !freeProductInCart &&
              otherProductInCart &&
              cartTotal >= window.giftProduct.giftThreshold
            ) {
              window
                .fetch(`${routes.cart_add_url}`, {
                  method: "POST",
                  credentials: "same-origin",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                  body: JSON.stringify(window.giftProduct),
                })
                .then(function (response) {
                  return response.json();
                })
                .then(function (json) {
                  if (json.status && json.status !== 200) {
                    var error = new Error(json.description);
                    error.isFromServer = true;
                    throw error;
                  }
                })
                .catch(function (error) {
                  // eslint-disable-next-line no-console
                  console.log(error);
                });
            }
          })
          .catch((e) => console.log(e));
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

if (!customElements.get("product-upsell")) {
  customElements.define(
    "product-upsell",
    class ProductUpsell extends HTMLElement {
      constructor() {
        super();
        this.loadUpsell();
      }

      loadUpsell() {
        console.log(this.dataset.productId);
        fetch(
          `${window.Shopify.routes.root}recommendations/products?product_id=${this.dataset.productId}&limit=1&section_id=product-upsell`,
        )
          .then((response) => response.text())
          .then((text) => {
            this.innerHTML = text;
            const productUpsellWrapper = this.querySelector(
              ".ProductUpsell--Wrapper",
            );
            productUpsellWrapper.addEventListener("click", (e) => {
              e.preventDefault();
              const isUpsellActive =
                !productUpsellWrapper.querySelector("input").checked;
              productUpsellWrapper.querySelector("input").checked =
                isUpsellActive;
              if (isUpsellActive) {
                console.log("dasda");

                if (
                  document
                    .querySelector(".price")
                    .classList.contains("price--on-sale")
                ) {
                  const totalPrice =
                    parseInt(productUpsellWrapper.dataset.price) +
                    parseInt(this.dataset.productPrice);
                  document.querySelector(
                    ".price .price__sale .price-item.price-item--sale",
                  ).innerHTML = Shopify.formatMoney(
                    totalPrice,
                    "{{amount_with_comma_separator}}€",
                  );

                  const totalSalePrice =
                    parseInt(productUpsellWrapper.dataset.price) +
                    parseInt(this.dataset.compareProductPrice);
                  document.querySelector(
                    ".price .price__sale .price-item.price-item--regular",
                  ).innerHTML = Shopify.formatMoney(
                    totalSalePrice,
                    "{{amount_with_comma_separator}}€",
                  );
                } else {
                  const totalPrice =
                    parseInt(productUpsellWrapper.dataset.price) +
                    parseInt(this.dataset.productPrice);
                  document.querySelector(
                    ".price .price__regular .price-item",
                  ).innerHTML = Shopify.formatMoney(
                    totalPrice,
                    "{{amount_with_comma_separator}}€",
                  );
                }
              } else {
                if (
                  document
                    .querySelector(".price")
                    .classList.contains("price--on-sale")
                ) {
                  const totalPrice = parseInt(this.dataset.productPrice);
                  document.querySelector(
                    ".price .price__sale .price-item.price-item--sale",
                  ).innerHTML = Shopify.formatMoney(
                    totalPrice,
                    "{{amount_with_comma_separator}}€",
                  );

                  const totalSalePrice = parseInt(
                    this.dataset.compareProductPrice,
                  );
                  document.querySelector(
                    ".price .price__sale .price-item.price-item--regular",
                  ).innerHTML = Shopify.formatMoney(
                    totalSalePrice,
                    "{{amount_with_comma_separator}}€",
                  );
                } else {
                  const totalPrice = parseInt(this.dataset.productPrice);
                  document.querySelector(
                    ".price .price__regular .price-item",
                  ).innerHTML = Shopify.formatMoney(
                    totalPrice,
                    "{{amount_with_comma_separator}}€",
                  );
                }
              }
            });
          });
      }

      getProduct() {
        const isUpsellActive = this.querySelector("input").checked;
        const variantId = document.querySelector(".ProductUpsell--Wrapper")
          .dataset.variantId;
        return isUpsellActive ? variantId : null;
      }
    },
  );
}

class ShopifyBreadcrumb extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.render();
    this.updateBreadcrumb();
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }
        nav {
          padding-bottom: 27px;
        }
        ol {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-wrap: wrap;
        }
        ol > svg {
          margin-left: 4px;
          margin-right: 4px; 
        } 
        li {
          display: flex;
          align-items: center;
        }
        a {
          color: #BDBCB8;
          text-decoration: none;
        }
        a:hover {
          text-decoration: underline;
          color: #88134B;
        }

        li > span {
          color: #59574E;
        }

        li > span,
        li > a {
          height: 12px;
          font-family: 'Overpass';
          font-style: normal;
          font-weight: 400;
          font-size: 13px;
          line-height: 120%;
        }
      </style>
      <nav aria-label="Breadcrumb">
        <ol>
          <li><a href="/">Home</a></li>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12L10 8L6 4" stroke="#737269" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <li id="collection-breadcrumb"></li>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 12L10 8L6 4" stroke="#737269" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <li id="product-breadcrumb"></li>
        </ol>
      </nav>
    `;
  }

  async updateBreadcrumb() {
    const collectionBreadcrumb = this.shadowRoot.getElementById(
      "collection-breadcrumb",
    );
    const productBreadcrumb =
      this.shadowRoot.getElementById("product-breadcrumb");

    const productHandle = this.getAttribute("product-handle");
    const productTitle = this.getAttribute("product-title");

    if (productHandle && productTitle) {
      productBreadcrumb.innerHTML = `<span>${productTitle}</span>`;

      const lastCollection = this.getCookie("lastCollection");
      if (lastCollection) {
        // User came from a collection page
        try {
          const response = await fetch(`/collections/${lastCollection}.json`);
          const { collection } = await response.json();
          collectionBreadcrumb.innerHTML = `<a href="/collections/${lastCollection}">${collection.title}</a>`;
          this.deleteCookie("lastCollection");
        } catch (error) {
          console.error("Error fetching collection:", error);
        }
      } else {
        // User came directly to the product page, show first collection
        try {
          const defaultCollectionTitle = this.getAttribute(
            "product-default-collection",
          );
          const defaultCollectionURL = this.getAttribute(
            "product-default-collection-url",
          );
          collectionBreadcrumb.innerHTML = `<a href="${defaultCollectionURL}">${defaultCollectionTitle}</a>`;
        } catch (error) {
          console.error("Error fetching product:", error);
        }
      }
    }
  }

  deleteCookie(name, path, domain) {
    if (this.getCookie(name)) {
      document.cookie =
        name +
        "=" +
        (path ? ";path=" + path : "") +
        (domain ? ";domain=" + domain : "") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }
}

customElements.define("shopify-breadcrumb", ShopifyBreadcrumb);
